import { actionTypes } from '~/src/features/full-buy/store';
import { IFlow } from '~/src/features/full-buy/store/initialState';

export const setFlow = (steps: IFlow) => {
    return {
        type: actionTypes.SET_FLOW,
        payload: {
            flow: steps,
        },
    };
};
